import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { InventoryCanvas } from "./components/InventoryComponent";
import { NpcComponent } from "./components/NpcComponent";
import { CalculatorComponent } from "./components/CalculatorComponent";

// Expose the web components to the browser
window.customElements.define("npc-component", NpcComponent);
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("inventory-component", InventoryCanvas);
window.customElements.define("game-calculator", CalculatorComponent);
